
export const common = {
  // Navigation
  home: 'Accueil',
  jobs: 'Offres d\'emploi',
  candidates: 'Candidats',
  services: 'Services',
  about: 'À propos',
  contact: 'Contact',
  
  // Auth
  login: 'Se connecter',
  register: 'S\'inscrire',
  logout: 'Se déconnecter',
  
  // Common actions
  search: 'Rechercher',
  filter: 'Filtrer',
  apply: 'Postuler',
  save: 'Enregistrer',
  cancel: 'Annuler',
  submit: 'Envoyer',
  edit: 'Modifier',
  delete: 'Supprimer',
  view: 'Voir',
  download: 'Télécharger',
  
  // Job related
  fullTime: 'Temps plein',
  partTime: 'Temps partiel',
  contract: 'Contrat',
  internship: 'Stage',
  remote: 'Télétravail',
  onSite: 'Sur site',
  hybrid: 'Hybride',
  salary: 'Salaire',
  experience: 'Expérience',
  location: 'Lieu',
  company: 'Entreprise',
  
  // Time
  hour: 'heure',
  hours: 'heures',
  day: 'jour',
  days: 'jours',
  week: 'semaine',
  weeks: 'semaines',
  month: 'mois',
  months: 'mois',
  year: 'année',
  years: 'années',
  
  // Status
  active: 'Actif',
  inactive: 'Inactif',
  pending: 'En attente',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  
  // Messages
  success: 'Succès',
  error: 'Erreur',
  warning: 'Attention',
  info: 'Information',
  loading: 'Chargement...',
  noResults: 'Aucun résultat trouvé',
  
  // Footer
  allRightsReserved: 'Tous droits réservés',
  privacyPolicy: 'Politique de confidentialité',
  termsOfService: 'Conditions d\'utilisation',
  
  // Hero section
  heroTitle: 'Trouvez votre emploi idéal dans la communauté maghrébine de Rouen',
  heroSubtitle: 'Connectez-vous avec des employeurs locaux et découvrez des opportunités d\'emploi adaptées à votre profil',
  heroSearchPlaceholder: 'Rechercher un emploi, une entreprise...',
  heroLocationPlaceholder: 'Ville, région...',
  
  // Services
  cleaning: 'Nettoyage',
  homeRepair: 'Réparation à domicile',
  elderCare: 'Aide aux personnes âgées',
  petCare: 'Garde d\'animaux',
  childCare: 'Garde d\'enfants',
  mechanics: 'Mécanique',
  administrative: 'Démarches administratives',
  translation: 'Traduction',
  
  // Administrative services
  administrativeTitle: 'Accompagnement Démarches Administratives',
  administrativeSubtitle: 'Traduction & Assistance Personnalisée',
  certifiedTranslation: 'Traduction Certifiée',
  prefectureServices: 'Démarches Préfecture',
  bankingServices: 'Démarches Bancaires',
  healthServices: 'Démarches Santé',
  schoolServices: 'Démarches Scolaires',
  housingServices: 'Démarches Logement',
  
  // Documents
  identityDocuments: 'Documents d\'identité',
  administrativeDocuments: 'Documents administratifs',
  schoolDocuments: 'Documents scolaires',
  medicalDocuments: 'Documents médicaux',
  legalDocuments: 'Documents juridiques',
  professionalDocuments: 'Documents professionnels',
  
  // Stats
  activeJobs: 'Offres actives',
  registeredCandidates: 'Candidats inscrits',
  successfulPlacements: 'Placements réussis',
  partnerCompanies: 'Entreprises partenaires'
};
